<template lang="html">
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    width="24px" height="24px" viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve">
        <path fill-rule="evenodd" clip-rule="evenodd" :fill="color" d="M11.986,1.98c-5.521,0-10,4.48-10,10c0,5.52,4.479,10,10,10c5.52,0,10-4.48,10-10
        C21.986,6.46,17.506,1.98,11.986,1.98z"/>
        <path fill-rule="evenodd" clip-rule="evenodd" fill="#FFFFFF" d="M15.258,9.449L15.258,9.449c0.537,0.434,0.892,1.096,0.903,1.836
        c0.774,0.338,1.313,1.109,1.313,2.008c0,1.205-0.979,2.188-2.188,2.188H7.845c-1.211,0-2.188-0.98-2.188-2.188
        c0-0.898,0.543-1.672,1.319-2.008c-0.004-0.061-0.006-0.121-0.006-0.181c0-1.692,1.373-3.063,3.063-3.063
        c0.229,0,0.443,0.023,0.658,0.071l0,0c0.384-0.819,1.216-1.386,2.18-1.386c1.33,0,2.408,1.078,2.408,2.406
        C15.279,9.24,15.271,9.346,15.258,9.449L15.258,9.449z"/>
        <path fill-rule="evenodd" clip-rule="evenodd" :fill="color" d="M12.986,7.824c-0.767,0-1.128,0.128-1.453,0.766
        c0.548,0.209,0.549,0.392,0.895,0.854c0.368-0.228,0.465-0.386,0.98-0.464c0.375-0.031,0.453-0.016,0.828,0.031
        C14.236,9.011,14.074,7.824,12.986,7.824z"/>
        <path fill-rule="evenodd" clip-rule="evenodd" fill="#FFFFFF" d="M7.406,17.607c0-0.633,1.101-1.688,1.101-1.688
        s1.088,1.057,1.088,1.688c0,0.451-0.355,0.939-1.088,0.939C7.772,18.547,7.406,18.096,7.406,17.607L7.406,17.607z"/>
        <path fill-rule="evenodd" clip-rule="evenodd" fill="#FFFFFF" d="M10.47,18.045c0-0.631,1.101-1.688,1.101-1.688
        s1.09,1.057,1.09,1.688c0,0.451-0.356,0.938-1.09,0.938C10.837,18.984,10.47,18.535,10.47,18.045L10.47,18.045z"/>
        <path fill-rule="evenodd" clip-rule="evenodd" fill="#FFFFFF" d="M13.535,17.607c0-0.633,1.1-1.688,1.1-1.688s1.09,1.057,1.09,1.688
        c0,0.451-0.355,0.939-1.09,0.939C13.901,18.547,13.535,18.096,13.535,17.607L13.535,17.607z"/>
        <path fill-rule="evenodd" clip-rule="evenodd" fill="#FFFFFF" d="M12.879,4.124c-0.272,0-0.492,0.211-0.492,0.49V5.59
        c0,0.268,0.229,0.486,0.492,0.486c0.272,0,0.492-0.212,0.492-0.486V4.614C13.371,4.342,13.143,4.124,12.879,4.124L12.879,4.124z"/>
        <path fill-rule="evenodd" clip-rule="evenodd" fill="#FFFFFF" d="M16.177,5.877c-0.191-0.191-0.498-0.199-0.695-0.003l-0.4,0.4
        c-0.188,0.19-0.184,0.509,0.006,0.692c0.191,0.193,0.496,0.198,0.689,0.002l0.402-0.398C16.37,6.381,16.36,6.063,16.177,5.877
        L16.177,5.877z"/>
        <path fill-rule="evenodd" clip-rule="evenodd" fill="#FFFFFF" d="M17.758,9.144c0-0.271-0.212-0.494-0.487-0.494h-0.98
        c-0.266,0-0.485,0.23-0.485,0.494c0,0.273,0.211,0.492,0.485,0.492h0.98C17.54,9.634,17.758,9.408,17.758,9.144L17.758,9.144z"/>
        <path fill-rule="evenodd" clip-rule="evenodd" fill="#FFFFFF" d="M9.585,5.956c-0.193,0.19-0.199,0.5-0.004,0.693l0.4,0.398
        c0.188,0.189,0.507,0.185,0.694-0.002c0.191-0.191,0.196-0.499,0.003-0.692l-0.4-0.4C10.088,5.762,9.772,5.771,9.585,5.956
        L9.585,5.956z"/>
    </svg>
</template>

<script>
import { navIcon } from '@/functions/appColors';

export default {
    props: {
        color: {
            default: String(navIcon),
            type: String,
        },
    },
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/icons/Climate.vue